import { render, staticRenderFns } from "./PuccFormIsFilled.vue?vue&type=template&id=51ab2445&"
import script from "./PuccFormIsFilled.vue?vue&type=script&lang=js&"
export * from "./PuccFormIsFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports